<template>
  <div class="flex">
    <button
      class="config-btn rounded-l border-r border-gray-700"
      :class="isItemActive ? 'bg-copper-800' : 'bg-gray-800'"
      @click="$emit('toggle-item')"
    >
      <slot name="icon">
        <div class="flex items-center justify-center w-5">
          <IconsThickness />
        </div>
      </slot>
    </button>
    <button class="config-btn bg-gray-800 rounded-r" @click="$emit('toggle-visibility')">
      <div>
        <EyeIcon v-if="visible" class="m-auto w-5 h-5" />
        <EyeSlashIcon v-else class="m-auto text-gray-600 w-5 h-5" />
      </div>
    </button>
  </div>
</template>

<script lang="ts" setup>
import IconsThickness from '@/components/icons/Thickness.svg'
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid'

defineProps({
  visible: {
    type: Boolean as PropType<boolean | undefined>,
    required: true,
  },
  isItemActive: {
    type: Boolean,
    required: true,
  },
})

defineEmits(['toggle-visibility', 'toggle-item'])
</script>

<style scoped>
.config-btn {
  @apply py-1.5 px-2.5;
}
</style>
